import { availableStoreList } from 'services/cart/types';
import {
  CD_AVAILAVILITY_MSG_SEQUENCE,
  CONTACT_DEALER_SEQUENCES
} from './constants';

export const getSourceDate = (dateString: string) => {
  const sourceDate = new Date(dateString?.split('|').at(-1));

  if (Number.isNaN(sourceDate.valueOf())) {
    return null;
  }

  return sourceDate;
};

export const getMonthAndDayFormatted = (date: Date) => {
  const monthText = date.toLocaleString('default', { month: 'long' });
  const month = `${monthText[0].toUpperCase()}${monthText.slice(1, 3)}`;
  const day = date.getDate().toString();

  return { month, day };
};

export const getSourceDetails = (
  storeList: availableStoreList[],
  quantityAvailable: number | string,
  availMessage: string,
  sequence: number
) => {
  const quantity = storeList
    ? storeList?.reduce((acc, curr) => acc + Number(curr.quantityAvailable), 0)
    : Number(quantityAvailable);
  const storeName = storeList ? storeList[0]?.storeName : availMessage;
  const isContactDealer = CONTACT_DEALER_SEQUENCES.includes(sequence);
  const message =
    sequence === CD_AVAILAVILITY_MSG_SEQUENCE ? availMessage : storeName;

  return { quantity, storeName, isContactDealer, message };
};
